// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1tdV9","buttons":"PendingPaymentAlert_buttons__3swPQ"};